<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      footerShow: true,
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path); //到哪去
      if (to.path == "/") {
        this.footerShow = false;
      } else {
        this.footerShow = true;
      }
    },
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
  created() {},
  mounted() {
    let _this = this;
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      // console.log(document.documentElement.clientWidth, "====12=");
      _this.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
    };
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .el-container {
    .el-header {
      width: 100%;
      position: fixed;
      top: 0%;
      z-index: 99;
      background: rgba(0, 0, 0, 0.1);
      color: rgb(96, 96, 96);
      // position: absolute;
      height: 94px;
      .logo {
        margin-left: 10%;
      }
      .el-menu-demo {
        margin-right: 20%;
      }
      .el-menu {
        background: none !important;
        color: #fff;
        font-family: "Open Sans", sans-serif;
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 600;
        display: inline-block;
        border: none !important;
      }
    }
  }
}
.el-menu--horizontal > .el-menu-item {
  color: #fff !important;
  background: none !important;
}
.el-menu--horizontal > .el-menu-item:hover {
  background: none !important;
  color: #ffc107 !important;
}
.el-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  // width: 1240px;
  margin: 0 auto;

  .logo {
    width: 280px;
    padding: 10px;
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: #14679f;
  // padding-top: 120px;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
